"use client";

import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { apiClient } from "@/services/api";
import { useNavigate } from "react-router-dom";

/**
 * 全局会话守卫组件
 * 在整个应用中检查用户会话有效性
 */
export default function SessionGuard({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // 定时检查会话有效性（被挤下线场景）
    let timer = null;
    const check = async () => {
      try {
        await apiClient.auth.getSession();
      } catch (e) {
        // 401/会话失效时，清除本地token以触发未登录态
        apiClient.clearToken();
        // 跳转到登录页
        navigate('/login');
      }
    };
    timer = setInterval(check, 30000); // 每30秒检查一次
    return () => timer && clearInterval(timer);
  }, [navigate]);

  // 首屏或任意时刻发现未认证，直接跳转登录（但避免在登录页面重复跳转）
  useEffect(() => {
    if (!loading && !isAuthenticated && window.location.pathname !== '/login') {
      navigate('/login');
    }
  }, [isAuthenticated, loading, navigate]);

  return children;
}
